import { FC } from 'react';
import { Forward, PickUpDetails } from 'ts/transfer/interfaces/TransferResultsResponse';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCar, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { dateFormat } from 'utils/transfer';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface BookingPreviewElementProps {
  data: Forward;
  title: string;
}

const BookingPreviewElement: FC<BookingPreviewElementProps> = ({ data, title }) => {
  const [t] = useTranslation();

  const getLocalle = (item: PickUpDetails) => {
    const locale = item.airport || item.city;
    return locale?.desc;
  };

  return (
    <div className="flight-details-info">
      <div className="title text-md mb-10 text-contrast">
        <FontAwesomeIcon className="mr-5" icon={faCar} size="sm" />
        {t(title)}
      </div>
      <div className="package-details-block">
        <span className="package-details-title">{t('flight.date')}</span>
        <span className="package-details-text">
          <FontAwesomeIcon icon={faCalendar as any} className="mr-5" />
          {dateFormat(data.transfer.pickUpDate, 'EEEE - dd MMMM yyyy')}
        </span>
      </div>
      <div className="package-details-block">
        <span className="package-details-title">{t('transfer.from')}</span>
        <span className="package-details-text">
          <FontAwesomeIcon icon={faLocationDot} className="mr-5" />
          {getLocalle(data.transfer.pickUpDetails)}
        </span>
      </div>
      <div className="package-details-block">
        <span className="package-details-title">{t('transfer.to')}</span>
        <span className="package-details-text">
          <FontAwesomeIcon icon={faLocationDot} className="mr-5" />
          {getLocalle(data.transfer.dropOffDetails)}
        </span>
      </div>
      <div className="package-details-block">
        <span className="package-details-title">{t('transfer.vehicle')}</span>
        <span className="package-details-text">
          <FontAwesomeIcon icon={faCar} className="mr-5" />
          {data.transfer.transferVehicles.length && data.transfer.transferVehicles[0]?.vehicle.desc}
        </span>
      </div>
      <div className="divider mt-20 mb-20"></div>
    </div>
  );
};

export default withErrorBoundary(BookingPreviewElement, 'BookingPreviewElement');
